export default "__VITE_ASSET__B6ToSC9H__"